//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";

const screen = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getScreens(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/screen?query=${query}`,
        obj
      );
      return handleResponse(res);
    }
    catch (err) {
      handleError(err);
    }
  }

  async function createScreen(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/screen`, obj);
      return handleResponse(res);
    }
    catch (err) {
      handleError(err);
    }
  }

  async function updateScreen(values) {
    try {
      const obj = {
        method: "PUT",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/screen`, obj);
      return handleResponse(res);
    }
    catch (err) {
      handleError(err);
    }
  }

  async function getRoles() {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(
        `${config.host}/cdr-panel/screen/get-roles`,
        obj
      );
      return handleResponse(res);
    }
    catch (err) {
      handleError(err);
    }
  }

  async function search(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/screen/search?query=${encodeURIComponent(query)}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  return {
    getScreens,
    createScreen,
    updateScreen,
    getRoles,
    search
  };
};

export default screen;
